import { grey, textMuted } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { radii } from '@/theme/tokens'
import styled from 'styled-components'

export const CountChipEl = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 12px;
	color: ${textMuted};
	background: ${grey};
	border-radius: ${radii.pill};
	padding: 3px 9px;
	white-space: nowrap;
	flex-shrink: 0;
`
